import { Controller } from '@hotwired/stimulus';
import axios from 'axios';
import Overlay from '../../../libs/cifra/overlay';

export default class extends Controller {
  connect() {
    this.page = 1;
    // URL donde se pedira el html
    this.url = this.element.dataset.url;
    // Id html donde añadiremos el partial que nos devuelve el servidor
    this.target = this.element.dataset.target;
    this.element.addEventListener('click', () => this.onClick());
    this.overlay = new Overlay('body', { position: 'centerScreen' });
  }

  onClick() {
    const page = this.page + 1;
    const url = new URL(this.url);
    url.searchParams.set('page', page);

    this.overlay.show();

    return axios.get(url.toString()).then((response) => {
      this.procesarRespuesta(response.data);
      this.page = page;
      this.overlay.hide();
    }).catch((error) => {
      this.overlay.hide();
      console.log(error);
    });
  }

  procesarRespuesta(html) {
    const nuevoDocumento = new DOMParser().parseFromString(html, 'text/html');
    const wrapper = nuevoDocumento.getElementById(this.target);

    const targetWrapper = document.getElementById(this.target);
    if (wrapper && wrapper.children.length) {
      Array.from(wrapper.children).forEach((child) => targetWrapper.appendChild(child));
    } else {
      this.finElementos();
    }
  }

  finElementos() {
    this.element.style.display = 'none';
  }
}
